import {  AttachmentDto } from './attachment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../models/api-response.model';
import { SearchDto1 } from '../../models/paging/request/search-dto';
import { RequestSearchResultDto } from 'src/app/modules/workFlow/models/request-models';
import { AttachmentSingle } from './attachmentsignle';

@Injectable({
  providedIn: 'root'
})
export class AttachmentService {

  constructor(private http: HttpClient) { }

  get(id: string): Observable<AttachmentDto> {
    return this.http.get<AttachmentDto>("/api/Attachment/" + id);
  }

 
  getAttachments(id: string): Observable<any> {
    return this.http.get<any>(`/api/Attachment/attachments/${id}`);
  }

  post(file: File): Observable<AttachmentDto> {
    let formData = new FormData();
    formData.append("file", file, file.name);
    return this.http.post<AttachmentDto>("attachment", formData);
  }

  delete(id: string): Observable<boolean> {
    return this.http.delete<boolean>("attachment" + "/" + id);
  }
}
